export default __webpack_public_path__ + "static/media/vukasin-vukoje.c2e252a3.png";